// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const skwovet: PokeData = {
  "id": 819,
  "name": "skwovet",
  "height": 3,
  "weight": 25,
  "base_experience": 55,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "tail-whip",
    "bite",
    "counter",
    "rest",
    "super-fang",
    "stockpile",
    "spit-up",
    "swallow",
    "bullet-seed",
    "belch",
    "stuff-cheeks"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "bite",
    "bullet-seed",
    "tri-attack",
    "leer",
    "headbutt",
    "splash",
    "scratch",
    "purification",
    "supersonic",
    "growl",
    "refresh"
  ],
  "evolution_chain": {
    "id": 433,
    "item": null,
    "species": [
      {
        "name": "skwovet",
        "order": 819,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "greedent",
        "order": 820,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 819,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 24,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 57.5,
    "speed": 25,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
